import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AlertOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';
import { Badge, Tooltip } from 'antd';

export default withRouter(function SeverityIcon() {

  return (
    <span style={{ float: 'right', height: '24.66px', width: '24.25px' }}> 
      <Tooltip placement="topRight" title="Project has Exception Forms" overlayStyle={{maxWidth: 'max-content'}}>
        <AlertOutlined style={{ fontSize: '12px', color: '#ff0000' }} />
          {/* <FontAwesomeIcon
            id={'severeIcon'}
            icon={severeIcon}
            pull={'left'}
            size='lg'
            style={{ color: '#ff0000' }}

          /> */}
          </Tooltip>   
    </span>
  );
});